var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/react/react": () => (loadSingletonVersion("default", "react", false, [,[4,19,1,0],[4,18,3,1],[4,17,0,2],1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__("./node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react-dom/react-dom": () => (loadSingletonVersion("default", "react-dom", false, [,[4,19,1,0],[4,18,3,1],[4,17,0,2],1,1], () => (__webpack_require__.e("vendors-node_modules_react-dom_index_js").then(() => (() => (__webpack_require__("./node_modules/react-dom/index.js"))))))),
	"webpack/sharing/consume/default/react-router-dom/react-router-dom": () => (loadSingletonVersion("default", "react-router-dom", false, [4,6,2,2], () => (Promise.all([__webpack_require__.e("vendors-node_modules_history_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-router_react-router"), __webpack_require__.e("node_modules_react-router-dom_index_js")]).then(() => (() => (__webpack_require__("./node_modules/react-router-dom/index.js"))))))),
	"webpack/sharing/consume/default/react/jsx-runtime/react/jsx-runtime": () => (loadSingletonVersion("default", "react/jsx-runtime", false, [4,17,0,2], () => (__webpack_require__.e("node_modules_react_jsx-runtime_js").then(() => (() => (__webpack_require__("./node_modules/react/jsx-runtime.js"))))))),
	"webpack/sharing/consume/default/websocket/websocket": () => (loadStrictVersion("default", "websocket", false, [1,1,0,34], () => (__webpack_require__.e("node_modules_websocket_lib_browser_js").then(() => (() => (__webpack_require__("./node_modules/websocket/lib/browser.js"))))))),
	"webpack/sharing/consume/default/universal-cookie/universal-cookie": () => (loadStrictVersion("default", "universal-cookie", false, [1,4,0,4], () => (__webpack_require__.e("node_modules_universal-cookie_es6_index_js").then(() => (() => (__webpack_require__("./node_modules/universal-cookie/es6/index.js"))))))),
	"webpack/sharing/consume/default/lodash/lodash": () => (loadStrictVersion("default", "lodash", false, [1,4,17,21], () => (__webpack_require__.e("vendors-node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__("./node_modules/lodash/lodash.js"))))))),
	"webpack/sharing/consume/default/styled-components/styled-components": () => (loadSingletonVersion("default", "styled-components", false, [4,5,3,11], () => (__webpack_require__.e("vendors-node_modules_styled-components_dist_styled-components_browser_esm_js").then(() => (() => (__webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js"))))))),
	"webpack/sharing/consume/default/react-helmet/react-helmet": () => (loadStrictVersion("default", "react-helmet", false, [1,6,1,0], () => (__webpack_require__.e("vendors-node_modules_react-helmet_es_Helmet_js").then(() => (() => (__webpack_require__("./node_modules/react-helmet/es/Helmet.js"))))))),
	"webpack/sharing/consume/default/react-router/react-router": () => (loadSingletonVersion("default", "react-router", false, [4,6,2,2], () => (Promise.all([__webpack_require__.e("vendors-node_modules_history_index_js"), __webpack_require__.e("vendors-node_modules_react-router_index_js")]).then(() => (() => (__webpack_require__("./node_modules/react-router/index.js"))))))),
	"webpack/sharing/consume/default/@amplitude/analytics-browser/@amplitude/analytics-browser": () => (loadStrictVersion("default", "@amplitude/analytics-browser", false, [1,2,11,7], () => (__webpack_require__.e("vendors-node_modules_amplitude_analytics-browser_lib_esm_index_js").then(() => (() => (__webpack_require__("./node_modules/@amplitude/analytics-browser/lib/esm/index.js"))))))),
	"webpack/sharing/consume/default/@amplitude/experiment-js-client/@amplitude/experiment-js-client": () => (loadStrictVersion("default", "@amplitude/experiment-js-client", false, [1,1,11,0], () => (__webpack_require__.e("vendors-node_modules_amplitude_experiment-js-client_dist_experiment_esm_js").then(() => (() => (__webpack_require__("./node_modules/@amplitude/experiment-js-client/dist/experiment.esm.js"))))))),
	"webpack/sharing/consume/default/@sentry/react/@sentry/react": () => (loadSingleton("default", "@sentry/react", false, () => (__webpack_require__.e("vendors-node_modules_sentry_react_build_esm_index_js").then(() => (() => (__webpack_require__("./node_modules/@sentry/react/build/esm/index.js"))))))),
	"webpack/sharing/consume/default/react-portal/react-portal": () => (loadStrictVersion("default", "react-portal", false, [1,4,2,0], () => (__webpack_require__.e("node_modules_react-portal_es_index_js").then(() => (() => (__webpack_require__("./node_modules/react-portal/es/index.js"))))))),
	"webpack/sharing/consume/default/react-transition-group/react-transition-group": () => (loadStrictVersion("default", "react-transition-group", false, [1,4,2,2], () => (__webpack_require__.e("vendors-node_modules_react-transition-group_esm_index_js").then(() => (() => (__webpack_require__("./node_modules/react-transition-group/esm/index.js"))))))),
	"webpack/sharing/consume/default/@amplitude/engagement-browser/@amplitude/engagement-browser": () => (loadStrictVersion("default", "@amplitude/engagement-browser", false, [3,0,0,6], () => (__webpack_require__.e("node_modules_amplitude_engagement-browser_index_js").then(() => (() => (__webpack_require__("./node_modules/@amplitude/engagement-browser/index.js"))))))),
	"webpack/sharing/consume/default/@amplitude/plugin-session-replay-browser/@amplitude/plugin-session-replay-browser": () => (loadStrictVersion("default", "@amplitude/plugin-session-replay-browser", false, [1,1,22,7], () => (__webpack_require__.e("vendors-node_modules_amplitude_plugin-session-replay-browser_lib_esm_index_js").then(() => (() => (__webpack_require__("./node_modules/@amplitude/plugin-session-replay-browser/lib/esm/index.js"))))))),
	"webpack/sharing/consume/default/classnames/classnames": () => (loadStrictVersion("default", "classnames", false, [1,2,3,2], () => (__webpack_require__.e("node_modules_classnames_index_js").then(() => (() => (__webpack_require__("./node_modules/classnames/index.js"))))))),
	"webpack/sharing/consume/default/downshift/downshift": () => (loadStrictVersion("default", "downshift", false, [1,6,1,7], () => (__webpack_require__.e("vendors-node_modules_downshift_dist_downshift_esm_js").then(() => (() => (__webpack_require__("./node_modules/downshift/dist/downshift.esm.js"))))))),
	"webpack/sharing/consume/default/react-highlight-words/react-highlight-words": () => (loadStrictVersion("default", "react-highlight-words", false, [2,0,17,0], () => (__webpack_require__.e("vendors-node_modules_react-highlight-words_dist_main_js").then(() => (() => (__webpack_require__("./node_modules/react-highlight-words/dist/main.js")))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_react_react": [
		"webpack/sharing/consume/default/react/react"
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		"webpack/sharing/consume/default/react-dom/react-dom"
	],
	"build_node_permissions_PermissionsContextProvider_js": [
		"webpack/sharing/consume/default/react-router-dom/react-router-dom",
		"webpack/sharing/consume/default/react/jsx-runtime/react/jsx-runtime",
		"webpack/sharing/consume/default/websocket/websocket",
		"webpack/sharing/consume/default/universal-cookie/universal-cookie",
		"webpack/sharing/consume/default/lodash/lodash",
		"webpack/sharing/consume/default/styled-components/styled-components",
		"webpack/sharing/consume/default/react-helmet/react-helmet"
	],
	"webpack_sharing_consume_default_react-router_react-router": [
		"webpack/sharing/consume/default/react-router/react-router"
	],
	"webpack_sharing_consume_default_amplitude_analytics-browser_amplitude_analytics-browser-webpa-9c6718": [
		"webpack/sharing/consume/default/@amplitude/analytics-browser/@amplitude/analytics-browser",
		"webpack/sharing/consume/default/@amplitude/experiment-js-client/@amplitude/experiment-js-client"
	],
	"build_node_components_AvatarDropdown_js-build_node_components_Copilot_CopilotTrigger_js-build-eb1190": [
		"webpack/sharing/consume/default/@sentry/react/@sentry/react",
		"webpack/sharing/consume/default/react-portal/react-portal",
		"webpack/sharing/consume/default/react-transition-group/react-transition-group"
	],
	"build_node_mount_js": [
		"webpack/sharing/consume/default/@amplitude/engagement-browser/@amplitude/engagement-browser",
		"webpack/sharing/consume/default/@amplitude/plugin-session-replay-browser/@amplitude/plugin-session-replay-browser",
		"webpack/sharing/consume/default/classnames/classnames",
		"webpack/sharing/consume/default/downshift/downshift"
	],
	"webpack_sharing_consume_default_react-highlight-words_react-highlight-words": [
		"webpack/sharing/consume/default/react-highlight-words/react-highlight-words"
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}